import { render } from "./sabko-scroll.vue?vue&type=template&id=17766e1b&scoped=true"
import script from "./sabko-scroll.vue?vue&type=script&lang=js"
export * from "./sabko-scroll.vue?vue&type=script&lang=js"

import "./sabko-scroll.vue?vue&type=style&index=0&id=17766e1b&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17766e1b"]])

export default __exports__